import center from '../assets/center/alarrab-center.jpg';
import whitining from '../assets/services/whitening/whitening.jpg';

import ortho from '../assets/services/ortho/ortho.png';
import kids from  '../assets/services/kids/kids.png';
import gums from '../assets/services/gums/gums.png';
import implants2 from '../assets/services/implants/implants2.png';
import implants from '../assets/services/implants/implants.jpg';

import nerve from '../assets/services/nerve/nerve.png';
import fillings from '../assets/services/fillings/fillings.png';


import t1 from '../assets/testimonials/t1.png';
import t2 from '../assets/testimonials/t2.png';
import t3 from '../assets/testimonials/t3.png';
import t4 from '../assets/testimonials/t4.png';
import t5 from '../assets/testimonials/t5.png';
const SITE = {
  clinic: {
    name: 'مركز العراب لطب الأسنان',
    nameEn: '',
    phone: '01070570222',
    whatsapp: 'https://wa.link/sy35gh',
    email: 'info@alarrabclinic.com',
    address: 'مصر الجديدة، ميدان سانت فاتيما، اعلى المصرف المتحد، الدور الثالث، شقة 1',
    address2 : ' مدينتى - ايست هب ميديكال سنتر',
    mapUrl: 'https://maps.app.goo.gl/z2UMErDs838cyhpu7',
    logo: './assets/logo/logo.png',
  },
  stats: [
    { num: '+1000', label: 'مريض راضٍ' },
    { num: '8',     label: 'خدمات' },
    { num: '+10',   label: 'سنوات خبرة' },
    { num: '100%',  label: 'رضا تام' },
  ],
  services: [
    {
      id: 'cosmetic', icon: '✨', title: 'تجميل الأسنان',
      desc: 'إجراء تجميلي للأسنان يهدف إلى تحقيق ابتسامة جميلة ومشرقة مثل ابتسامة هوليود.',
      img: whitining,
      content: [
        { h: 'ابتسامة هوليوود', p: 'ابتسامة هوليود هي إجراء تجميلي للأسنان يهدف إلى تحقيق ابتسامة جميلة ومشرقة. يتضمن هذا الإجراء تركيب قشور صناعية رقيقة على الأسنان، وتصميمها وفقًا للشكل والحجم المناسب لكل فرد. وتستخدم أجود أنواع الفينيرز في مركز العراب للوصول إلى أفضل نتيجة.' },
        { h: 'أنواع الفينير', ul: ['فينير البورسلين: المفضل للمرضى الذين يرغبون في تغيير حجم أو شكل أو لون أسنانهم.', 'فينير السيراميك: أحد أنواع الفينير الأكثر استخدامًا على نطاق واسع.', 'فينير الأسنان المختلط: يمكن زرعه من خلال عملية واحدة.'] },
        { h: 'تبييض الأسنان', p: 'تبييض الأسنان هو إجراء يستخدم لتفتيح لون الأسنان لعدة درجات باستخدام تقنية الليزر المتطورة.' },
        { h: 'مميزات تجميل الأسنان في مركز العراب', ul: ['أفضل التقنيات العالمية في تجميل الأسنان وتحقيق ابتسامة المشاهير.', 'نخبة من أطباء الفم والأسنان ذوي الخبرة العالية.', 'تنفيذ جميع الإجراءات بأحدث التقنيات الطبية.', 'الحفاظ على صحة اللثة وعدم إلحاق أي أضرار.'] },
      ]
    },
    {
      id: 'implants2', icon: '🔬', title: 'زراعة الأسنان',
      desc: 'إجراء جراحي يهدف إلى استبدال الأسنان المفقودة بأسنان صناعية ثابتة.',
      img: implants2,
      content: [
        { h: 'زراعة الأسنان', p: 'زراعة الأسنان هي إجراء جراحي يهدف إلى استبدال الأسنان المفقودة بأسنان صناعية ثابتة. تتم عملية الزراعة عن طريق إدخال جذور صناعية مصنوعة من التيتانيوم في الفك العلوي أو السفلي، وتتكامل هذه الجذور مع العظم المحيط لتوفير أساس قوي للأسنان الصناعية.', highlight: true },
        { h: 'أنواع زرعات الأسنان في مركز العراب', ul: ['الزراعات السويسرية: تتميز بالاندماج السريع مع العظم والحفاظ على صحة أنسجة اللثة.', 'الزراعات الألمانية: تتميز بالقوة والمتانة العالية وسرعة التئامها مع العظام.', 'زرعات Zimmer Biomet الأمريكية: أحدث التقنيات الطبية بتصميمات متنوعة ومواد عالية الجودة.'] },
        { h: 'مميزات زراعة الأسنان في مركز العراب', ul: ['تقنيات حديثة ونتائج جذابة بدون مضاعفات.', 'فريق طبي متخصص في الزراعة المتقدمة والمواد ذات الجودة العالية.', 'بيئة مريحة وتقنيات تخدير حديثة لضمان راحة المريض.', 'دعم ومتابعة مستمرة في جميع مراحل العلاج.'] },
      ]
    },
    {
      id: 'implants', icon: '👑', title: 'تركيبات الاسنان',
      desc: 'إجراء يهدف إلى استبدال الأسنان المفقودة أو التالفة بقطع صناعية عالية الجودة.',
      img: implants,
      content: [
        { h: 'تركيبات الاسنان', p: 'تركيب الأسنان هو إجراء يهدف إلى استبدال الأسنان المفقودة أو التالفة بقطع صناعية، بهدف استعادة وظيفة الأسنان الطبيعية وتحقيق المظهر الجمالي المشابه للأسنان الأصلية.' },
        { h: 'أنواع تركيبات الأسنان', ul: ['تركيبات البورسلين: تتميز بجمالية شكلها وقوتها وصلابتها.', 'تركيبات الزيركون: الخيار الأكثر شيوعًا والأكثر تطورًا حاليًا.', 'تركيبات Biohpp: تُستخدم في زراعات الأسنان وحالات الفك الكاملة.', 'تركيبات PMMA: للتركيبات المؤقتة بشكل جمالي مميز.'] },
        { h: 'مميزات تركيبات الأسنان في مركز العراب', ul: ['خبرة وكفاءة عالية لدى الفريق الطبي المتخصص.', 'استخدام أفضل المواد والتقنيات الحديثة.', 'تشخيص دقيق لكل حالة على حدة.', 'متابعة ما بعد العلاج لضمان أفضل النتائج.'] },
      ]
    },
    {
      id: 'fillings', icon: '🦷', title: 'الحشوات التجميلية',
      desc: 'حشوات ذات لون يتطابق مع لون الأسنان، بديل تجميلي عن الحشوات التقليدية.',
      img: fillings,
      content: [
        { h: 'الحشوات التجميلية', p: 'الحشوات التجميلية هي حشوات ذات لون يتطابق مع لون الأسنان، وتعتبر بديلاً عن الحشوات التقليدية. تُستخدم هذه الحشوات لتعويض وسد الفراغات الناتجة عن التسوس والكسور في الأسنان بشكل تجميلي.' },
        { h: 'أنواع الحشوات التجميلية', ul: ['حشوة الكمبوزيت: لونها الطبيعي قريب جداً من لون الأسنان الحقيقية.', 'حشوة السيراميك: متانة عالية ومقاومة للبقع.', 'حشوة الأيونومير: حشوة زجاجية تجميلية ممتازة.', 'الحشوات المركبة: تجمع صفات الكمبوزيت والجلاس ايونومير.'] },
        { h: 'مميزات الحشوات التجميلية في مركز العراب', ul: ['فريق طبي متخصص ذو خبرة عالية.', 'خطط علاج مخصصة لكل حالة.', 'استخدام أحدث التقنيات والمواد.', 'متابعة دورية لضمان النتائج المطلوبة.'] },
      ]
    },
    {
      id: 'nerve', icon: '💉', title: 'حشو العصب',
      desc: 'إجراء طبي يتم تنفيذه في عيادة الأسنان لعلاج تلف العصب في السن.',
      img: nerve,
      content: [
        { h: 'حشو العصب', p: 'حشو العصب يعد إجراءً طبياً يتم تنفيذه في عيادة الأسنان لعلاج تلف العصب في السن. يتم تنفيذ هذا الإجراء عندما يتأثر العصب بالتسوس العميق، الإصابة أو الالتهاب.' },
        { h: 'خطوات حشو العصب', ul: ['تخدير موضعي: لتخدير السن ومنطقة العصب وتقليل الألم.', 'فتح القناة: إزالة الجزء المصاب من العصب وتنظيف القناة.', 'حشو القناة: ملء المساحة بمادة خاصة تمنع تسرب البكتيريا.', 'إعادة الترميم: وضع حشوة أو تاج لحماية السن المعالج.'] },
        { h: 'مميزات حشو العصب في مركز العراب', ul: ['فريق طبي متخصص بأحدث التقنيات العالمية.', 'تقنية حشو القنوات ثلاثية الأبعاد لإحكام الغلق.', 'الحفاظ على السن الأصلي وعدم اللجوء للقلع.', 'أحدث التقنيات والأجهزة التشخيصية والعلاجية.'] },
      ]
    },
    {
      id: 'ortho', icon: '😁', title: 'تقويم الاسنان',
      desc: 'أسلوب علاجي متقدم يساعد على تحسين شكل الاسنان واستعادة الابتسامة الطبيعية.',
      img: ortho,
      content: [
        { h: 'تقويم الاسنان', p: 'تقويم الأسنان هو أسلوب علاجي متقدم يساعد المرضى على تحسين شكل أسنانهم عندما تكون غير مستقيمة أو تعاني من أي عيوب. ويعتبر تقويم الأسنان ضرورة في سن صغير لمساعدة المرضى على استعادة الابتسامة الطبيعية.' },
        { h: 'أنواع تقويم الأسنان', ul: ['التقويم الشفاف: شفاف وشبه غير مرئي، مريح للاستخدام.', 'التقويم المعدني: للتعديل الدقيق، مثبت بصورة دائمة على الأسنان.', 'تقويم الأسنان المتحرك: أجزاء قابلة للإزالة، للحالات البسيطة.'] },
        { h: 'مميزات تقويم الأسنان في مركز العراب', ul: ['فريق طبي متخصص وذوو خبرة ومهارة.', 'خطط علاج مخصصة مع توضيح مراحل العلاج.', 'أحدث التقنيات في تقويم الأسنان.', 'متابعة دورية لضمان النتائج.'] },
      ]
    },
    {
      id: 'gum', icon: '🌿', title: 'تجميل اللثة',
      desc: 'إجراء لتحسين مظهر وشكل اللثة المحيطة بالأسنان للوصول لابتسامة متكاملة.',
      img: gums,
      content: [
        { h: 'تجميل اللثة', p: 'تجميل اللثة هو إجراء يتم تنفيذه لتحسين مظهر وشكل اللثة المحيطة بالأسنان. يهدف إلى إعطاء اللثة مظهرًا أكثر جمالية وتناسبًا مع الأسنان والوجه، أو لاعادة لونها الأحمر الوردي الصحي.' },
        { h: 'أنواع تجميل اللثة', ul: ['استئصال/تركيب اللثة: لعلاج اللثة المتضخمة أو المتراجعة.', 'تصحيح لون اللثة: تقنيات تبييض لتحسين وتوحيد اللون.', 'طواف اللثة: لتحسين مظهر وتناسق خط اللثة.'] },
        { h: 'مميزات تجميل اللثة في مركز العراب', ul: ['تشخيص دقيق وتحديد احتياجات المريض.', 'تقنيات متقدمة مثل الليزر والزراعة اللثوية.', 'نتائج دائمة وطبيعية.', 'متابعة ما بعد العلاج.'] },
      ]
    },
    {
      id: 'kids', icon: '👶', title: 'طب اسنان الأطفال',
      desc: 'رعاية متخصصة تختلف عن رعاية أسنان البالغين تهدف للحفاظ على بناء الأسنان.',
      img: kids,
      content: [
        { h: 'طب اسنان الأطفال', p: 'تختلف رعاية أسنان الأطفال عن رعاية أسنان البالغين، حيث يكون هناك تحديات واحتياجات خاصة. وتهدف رعاية أسنان الأطفال للمساعدة في الحفاظ على الأسنان الصحية واللثة السليمة.', highlight: true },
        { h: 'المشكلات الأكثر شيوعًا', ul: ['تأخر ظهور الأسنان الدائمة — يستدعي تقييم الطبيب.', 'تبديل الأسنان اللبنية مبكراً قبل أن تسقط بشكل طبيعي.', 'خلل في الفك نتيجة عادات مثل مص الأصابع.', 'تسوس الأسنان — يتطلب علاجاً فورياً.', 'الصدمات والكسور — تستوجب استشارة طبية عاجلة.'] },
      ]
    },
  ],
  testimonials: [
    { name: 'خالد جمال',  role: 'تجميل أسنان',    text: '' , img:t1},
    { name: 'يمني محمد',  role: 'تبييض أسنان',    text: '' , img:t2},
    { name: 'محمد مجدي',  role: 'زراعة أسنان',    text: '' , img:t3},
    { name: 'مني مصطفى', role: 'تقويم أسنان',    text: '' , img:t4 },
    { name: 'أحمد ياسر',  role: 'ابتسامة هوليوود', text: '' , img:t5},
  ],
  faq: [
    { q: 'كيف يمكنني الحفاظ على صحة الأسنان الجيدة؟', a: 'تنظيف الأسنان مرتين يوميًا بفرشاة ناعمة ومعجون فلورايد، استخدام خيط الأسنان يوميًا، الابتعاد عن التدخين، الحمية الغذائية الصحية وتجنب السكريات، وزيارة طبيب الأسنان كل ستة أشهر للفحص الدوري والتنظيف المهني.' },
    { q: 'ما هو التسوس وكيف يمكن علاجه؟', a: 'تسوس الأسنان هو حالة يتعفن فيها أجزاء من الأسنان. يُعالج بالفلورايد، الحشوات المركبة، علاج عصب السن، التاج الكامل، أو الخلع في الحالات الشديدة فقط.' },
    { q: 'ما هي أعراض التهاب اللثة؟', a: 'احمرار اللثة وتورمها، النزيف عند التنظيف، رائحة الفم الكريهة، انكشاف اللثة في الحالات المتقدمة، والألم في المنطقة الملتهبة.' },
    { q: 'ما هي الأسباب الشائعة لسقوط مسمار زراعة الأسنان؟', a: 'عدم التكامل العظمي، التهاب اللثة المزمن، تجاويف الفم، الضغط الزائد على المسمار الزرعي، ومشكلات في التصميم أو التركيب.' },
  ],
};

export default SITE;
